import React from 'react';
import { useSelector } from 'react-redux';

// import selectors
import { getOnlineStatus } from 'js/store/app/App.selectors';

import defaultCardImage from '../../../images/static/card_default.jpg';

const Thumbnail = ({ src, alt, caption }) => {
  const isOnline = useSelector(getOnlineStatus);

  return (
    <figure className="thumbnail">
      <img
        src={isOnline ? src : defaultCardImage}
        alt={alt}
        onError={(e) => {
          e.currentTarget.onerror = null;
          e.currentTarget.src = defaultCardImage;
        }}
      />
      {caption && <figcaption>{caption}</figcaption>}
    </figure>
  );
};

export default Thumbnail;
